module.exports = __webpack_public_path__ + "src/images/products/trendsetter/118_Blue Joy Division Substance Side Closure Shirt.png";